import { Conversation } from "@twilio/conversations";
import { ConversationClientEvent } from "~/modules/client/Client/ClientEvent";
import { Client } from "~/modules/client/Client/Client";
import { Action } from "~/modules/actions/Action";
import { ClientImpl } from "~/modules/client/Client/ClientImpl/ClientImpl";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { getLogger } from "~/modules/logger/LoggerFactory/getLogger";
import { LoggerName } from "~/modules/logger/Logger/LoggerName";
import { ConversationsSdkImpl } from "~/modules/conversations/ConversationsSdkImpl";
import { ConversationImpl } from "~/modules/Conversation";























export class AddConversationEventListener implements Action<Promise<Client>> {
    readonly #eventName: ConversationClientEvent;

    readonly #listener: (...args: unknown[]) => void;

    constructor(eventName: ConversationClientEvent, listener: (...args: unknown[]) => void) {
        this.#eventName = eventName;
        this.#listener = listener;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const client = context.retrieveInstanceOf(ContextInstance.ClientImpl, ClientImpl);
        const conversationSdk = context.retrieveInstanceOf(ContextInstance.ConversationsSdkImpl, ConversationsSdkImpl);
        const logger = getLogger(context)(LoggerName.Client);

        try {
            try {
                await conversationSdk.init();
            } catch (e) {
                logger.error("Failed to initialise ConversationSdk", e);
            }
            conversationSdk.conversationsClient.on(this.#eventName, (addedConversation: Conversation) => {
                const conversation = new ConversationImpl(context, addedConversation);
                client.emitter.emit(this.#eventName, conversation);
            });
            const newClient = client.addListener(this.#eventName, this.#listener);
            return newClient as Client;
        } catch (error) {
            logger.error("Failed to add conversation event listener to client.", error);
        }

        return client as Client;
    }
}
